import {
  FETCH_PROMO_CODES_DATA,
  FETCH_PROMO_CODES_SUCCESS,
  FETCH_PROMO_CODES_FAILURE,
  FETCH_PROMO_CODES_EDIT_DATA,
  FETCH_PROMO_CODES_EDIT_SUCCESS,
  FETCH_PROMO_CODES_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const promocodes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROMO_CODES_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_PROMO_CODES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_PROMO_CODES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_PROMO_CODES_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_PROMO_CODES_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_PROMO_CODES_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default promocodes;
